/**
 * Enables user feedback on product tile.
 * https:www.notion.so/faire/Negative-User-Feedback-926553af98e24cdfad8586ee8bd50557
 */
export const USER_FEEDBACK_ON_PRODUCT_TILE_240826 = 'USER_FEEDBACK_ON_PRODUCT_TILE_240826';
